export default __webpack_public_path__ + "static/media/illus17.8e760924.png";